import { GetDetailsResponseType } from 'QuoteApp/services/endpoints/GetDetails';
import { useCallback, useState } from 'react';
import { useLazyRewardsApi } from 'Shared/services/Api';

type EstimateRewardPointsRequest = GetDetailsResponseType;

export type EstimateRewardPointsProviderType = {
  isEstimatePointsLoading: boolean;
  submitEstimatePoints(
    details: EstimateRewardPointsRequest
  ): Promise<EstimateRewardPointsResponse | null>;
  estimatePointsResponse: EstimateRewardPointsResponse | null;
  rewardsPointsError: boolean;
};

export declare type EstimateRewardPointsResponse = {
  processedRules: Array<{
    pointsEarned: number;
    rule: string;
  }>;
  failedRules: Array<{ ruleName: string }>;
  totalPoints: number;
};

export const useEstimateRewardPoints = (): EstimateRewardPointsProviderType => {
  const [
    { loading: submittingEstimatePoints, error },
    estimatePoints,
  ] = useLazyRewardsApi<EstimateRewardPointsResponse>({
    url: `/v2/estimate`,
    method: 'POST',
  });
  const [
    estimatePointsResponse,
    setEstimatePointsResponse,
  ] = useState<EstimateRewardPointsResponse | null>(null);

  const submitEstimatePoints = useCallback(
    (details: EstimateRewardPointsRequest) => {
      return estimatePoints({
        data: details,
      })
        .then(async response => {
          setEstimatePointsResponse(response.data);
          return response.data;
        })
        .catch(() => {
          return null;
        });
    },
    [estimatePoints]
  );

  return {
    isEstimatePointsLoading: submittingEstimatePoints,
    submitEstimatePoints: submitEstimatePoints,
    estimatePointsResponse,
    rewardsPointsError: !!error,
  };
};
